export interface IPurgeFailure {
  companyId: number
  error: unknown
}

export interface IRemoveCompaniesResult {
  removedCompanyIds: number[]
  purgeFailures: IPurgeFailure[]
}

export const removeCompaniesAndPurgeProducts = async (
  organizationId: number,
  companyIds: number[],
  deps: {
    removeCompany: (organizationId: number, companyId: number) => Promise<void>
    purgeOrgProducts: (organizationId: number, companyId: number) => Promise<void>
  },
): Promise<IRemoveCompaniesResult> => {
  const removedCompanyIds: number[] = []
  const purgeFailures: IPurgeFailure[] = []

  for (const companyId of companyIds) {
    await deps.removeCompany(organizationId, companyId)
    removedCompanyIds.push(companyId)

    try {
      await deps.purgeOrgProducts(organizationId, companyId)
    } catch (error) {
      purgeFailures.push({ companyId, error })
    }
  }

  return { removedCompanyIds, purgeFailures }
}

export const retryPurges = async (
  organizationId: number,
  companyIds: number[],
  purgeOrgProducts: (organizationId: number, companyId: number) => Promise<void>,
): Promise<IPurgeFailure[]> => {
  const purgeFailures: IPurgeFailure[] = []

  for (const companyId of companyIds) {
    try {
      await purgeOrgProducts(organizationId, companyId)
    } catch (error) {
      purgeFailures.push({ companyId, error })
    }
  }

  return purgeFailures
}
